const validateCategoryIds = (rule, value, callback) => {
    if (value.length === 0) {
        callback(new Error('请选择类目'));
    } else {
        callback();
    }
}
const validateTitle = (rule, value, callback) => {
    const regx = /^\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]$/;
    if (regx.test(value)) {
        callback(new Error('不能含emoj表情'));
    } else if (value.length > 50) {
        callback(new Error('最多50个字符'))
    } else {
        callback();
    }
}
const validateBrandId = (rule, value, callback, context) => {
    if(context.length){
        callback(new Error("请完善品牌部分"))
    }else{
        callback()
    }
}
const validateShopCategories = (rule, value, callback, context) => {
    if(context.length){
        callback(new Error("请完店内分类部分"))
    }else{
        callback()
    }
}

const validateWeight = (rule, value, callback, context) => {
    console.log('value:',value)
    if(!value || value == '0'){
        callback(new Error("请输入商品重量"))
    }else{
        callback()
    }
}
const validatePrice = (rule, value, callback, context) => {
    console.log('value:',value)
    if(!value || value == '0'){
        callback(new Error("请输入商品价格"))
    }else{
        callback()
    }
}


// 若需要vm上下文请用此函数包裹
function contextWrap(fn, context) {
    return (rule, value, callback) => fn(rule, value, callback, context)
}

const RULES = function(context) {
    return {
        categoryIds: [
            {required: true, message: '请选择类目'},
            {validator: validateCategoryIds}
        ],
        outerId:[
            {required: true, message: '请输入商家编码'},
        ],
        title: [
            {required: true, message: '请输入商品名称'},
            {validator: validateTitle},
        ],
        weight:[
            {required: true, message: '请输入商品重量'},
            {validator: validateWeight},
        ],
        price:[
            {required: true, message: '请输入商品价格'},
            {validator: validatePrice},
        ],
        brandList:[
            {required: true, message: '请选择品牌'},
            {validator: validateBrandId},
        ],
        shopCategories:[
            {required: true, message: '请选择店内分类'},
            {validator: validateShopCategories},
        ],
    };
}

export {
    RULES as default,
    validateTitle,
    validateBrandId,
    validateShopCategories,
    contextWrap
};